import { Component, OnInit } from '@angular/core';
import { Title, Meta} from '@angular/platform-browser';
import { TranslateService, LangChangeEvent } from '@ngx-translate/core';

@Component({
  selector: 'app-contacts',
  templateUrl: './contacts.component.html',
  styleUrls: ['./contacts.component.scss']
})
export class ContactsComponent implements OnInit {

  constructor(
    private titleService: Title,
    private metaService: Meta,
    private translate: TranslateService,
  ) { }

  ngOnInit() {
    if (this.translate.currentLang === 'en') {
      this.titleService.setTitle('Voyager - Contact us');
      this.metaService.addTags([
        { name: 'description', content: 'For more informations, contact us !' },
        { name: 'keywords', content: 'contact Voyager' }
      ]);
    } else if (this.translate.currentLang === 'fr') {
      this.titleService.setTitle('Voyager - Contactez-nous');
      this.metaService.addTags([
        { name: 'description', content: 'Pour plus d\'informations contactez-nous !' },
        { name: 'keywords', content: 'contact Voyager' }
      ]);
    }

    this.translate.onLangChange.subscribe((event: LangChangeEvent) => {

      if (this.translate.currentLang === 'en') {
        this.titleService.setTitle('Voyager - Contact us');
        this.metaService.updateTag({
          name: 'description',
          content: 'For more informations, contact us !'
        });
        this.metaService.updateTag({
          name: 'keywords',
          content: 'contact Voyager'
        });

      } else if (this.translate.currentLang === 'fr') {
        this.titleService.setTitle('Voyager - Contactez-nous');
        this.metaService.updateTag({
          name: 'description',
          content: 'Pour plus d\'informations contactez-nous !'
        });
        this.metaService.updateTag({
          name: 'keywords',
          content: 'contact Voyager'
        });
      }
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/contacts/contacts.component.ts